export default __webpack_public_path__ + "static/media/ammar.2be7c4f6.webp";